// Customer-order status display helpers (statuses from api.CustomerOrder).

export const ORDER_STATUS_LABELS = {
  new: 'New',
  confirmed: 'Confirmed',
  in_production: 'In Production',
  ready_to_ship: 'Ready to Ship',
  partially_shipped: 'Partially Shipped',
  complete: 'Complete',
  cancelled: 'Cancelled',
};

export const ORDER_STATUS_COLORS = {
  new: 'default',
  confirmed: 'info',
  in_production: 'primary',
  ready_to_ship: 'success',
  partially_shipped: 'warning',
  complete: 'success',
  cancelled: 'error',
};

export function orderStatusLabel(status) {
  return ORDER_STATUS_LABELS[status] || status || '';
}

export function orderStatusColor(status) {
  return ORDER_STATUS_COLORS[status] || 'default';
}
